import type { FC } from 'react'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { tokens } from '@/locales/tokens'
import { routes } from '@/routes'
import type { DocumentTitleTokenRef } from '@/types/route-handle'
import { getDocumentTitleRefForPathname } from './utils'

function resolveTokenPath(ref: DocumentTitleTokenRef): string | undefined {
  const bucket = tokens[ref.namespace] as Record<string, string> | undefined
  return bucket?.[ref.key]
}

/**
 * Définit le titre d’onglet à partir du `handle` de la route la plus profonde : « {segment} | Nabu »,
 * ou « Nabu » si aucune route ne définit `documentTitle`.
 */
export const DocumentTitle: FC = () => {
  const { pathname } = useLocation()
  const { t } = useTranslation()

  const ref = getDocumentTitleRefForPathname(pathname, routes)
  const tokenPath = ref ? resolveTokenPath(ref) : undefined
  const segment = tokenPath ? (t(tokenPath) as string) : ''
  const fullTitle = segment ? `${segment} | Nabu` : 'Nabu'

  return (
    <Helmet>
      <title>{fullTitle}</title>
    </Helmet>
  )
}
